export default "__VITE_ASSET__zXGyl5Sx__"